import {
  anthracite,
  iPacRed,
  lightGreen,
  mediumGreen,
  red,
} from '@components/hoc/Theme/Theme.styled';
import { isIpac } from '@config/constants';
import styled from 'styled-components';
import {keyframes} from 'styled-components';

const AppearAsError = keyframes`
  from
  {
    fill: ${mediumGreen};
  }
  to
  {
    fill: ${red};
  }
`;

const Disapear = keyframes`
  from
  {
    fill: ${mediumGreen};
  }
  to
  {
    fill: ${red};
  }
`;

export const SvgIcon = styled.svg`
  width: 15px;
  height: 15px;
`;

export const SvgArrowBackground = styled.svg`
  position: absolute;
  left: 0;
  width: 80%;
  max-height: 80%;
  top: 50%;
  transform: translate(0, -50%);
`

export const SvgAvisVerifies = styled.svg`
  width: 59px;
  .cls-1 {
    fill: #090912;
  }

  .cls-1, .cls-2 {
    stroke-width: 0;
  }

  .cls-2 {
    fill: ${ isIpac ? iPacRed : '#006FFF' };
  }
`;

export const SvgArrowDown = styled.svg`
    position: relative;
    fill: ${mediumGreen};
    margin: 7px 0px 0px 10px;
    height: 28px;
    top: 5px;
}
`;

export const SvgArrowLeft = styled.svg`
    position: relative;
    fill: ${anthracite};
    margin: 7px 0px 0px 0px;
    height: 28px;
    top: 5px;
    transform: rotate(90deg);
}`;

export const SvgArrowUp = styled.svg`
    position: relative;
    fill: ${mediumGreen};
    margin: 7px 0px 0px 10px;
    height: 28px;
    top: 5px;
    transform: rotate(180deg);
}
`;

export const SvgErrorHat = styled.svg`
  width: 90%;
  fill: ${red};
  animation: ${(props) => (props.$out ? AppearAsError : Disapear)} 1.5s ease-out;
`;

export const SvgIconCross = styled(SvgIcon)`
  position: absolute;
  z-index: 1;
  fill: ${red};
  top: 50%;
  right: 5%;
`;

export const SvgIconCheck = styled(SvgIcon)`
  position: absolute;
  z-index: 1;
  fill: ${lightGreen};
  top: 50%;
  right: 5%;
`;
